// extracted by mini-css-extract-plugin
export default {"TriggeredTransactionsAmountPortletStub":"index__TriggeredTransactionsAmountPortletStub__RJm45"};